/**
 * Ensures that a given path ends with a slash ("/") or not, depending on the `needsSlash` parameter.
 * @param path The path to ensure.
 * @param needsSlash Whether the path should end with a slash or not.
 * @returns The path with or without a slash at the end.
 */
export function ensureSlash(path = '', needsSlash = true) {
	const hasSlash = path.endsWith('/')
	if (hasSlash && !needsSlash) {
		return path.slice(0, -1)
	}
	if (!hasSlash && needsSlash) {
		return `${path}/`
	}

	return path
}
